var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16669 2.5C8.50365 2.5 7.86776 2.76339 7.39892 3.23223C6.93008 3.70107 6.66669 4.33696 6.66669 5V5.83333H4.16669C3.50365 5.83333 2.86776 6.09673 2.39892 6.56557C1.93008 7.03441 1.66669 7.67029 1.66669 8.33333V15C1.66669 15.663 1.93008 16.2989 2.39892 16.7678C2.86776 17.2366 3.50365 17.5 4.16669 17.5H15.8334C16.4964 17.5 17.1323 17.2366 17.6011 16.7678C18.07 16.2989 18.3334 15.663 18.3334 15V8.33333C18.3334 7.67029 18.07 7.03441 17.6011 6.56557C17.1323 6.09673 16.4964 5.83333 15.8334 5.83333H13.3334V5C13.3334 4.33696 13.07 3.70107 12.6011 3.23223C12.1323 2.76339 11.4964 2.5 10.8334 2.5H9.16669ZM11.6667 5.83333H8.33335V5C8.33335 4.77899 8.42115 4.56702 8.57743 4.41074C8.73371 4.25446 8.94567 4.16667 9.16669 4.16667H10.8334C11.0544 4.16667 11.2663 4.25446 11.4226 4.41074C11.5789 4.56702 11.6667 4.77899 11.6667 5V5.83333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitcase);
export default __webpack_public_path__ + "static/media/suitcase.f3d4ac76a0415c41dd06f9d95f6df26d.svg";
export { ForwardRef as ReactComponent };